import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppImage from '../../../components/AppImage';


const BrandHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center mb-6 md:mb-8">
      <button
        onClick={() => navigate('/')}
        className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-2xl md:rounded-3xl mb-4 md:mb-6 transition-transform hover:scale-105"
        style={{ backgroundColor: 'var(--color-primary-light)' }}
      >
        <AppImage
          src="/assets/images/RVS_InitialLogo_01-02-1768324259986.png"
          alt="Radiavision Studio Logo - Professional gallery management platform"
          className="w-10 h-10 md:w-14 md:h-14 object-contain"
        />
      </button>
      <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-2 md:mb-3" style={{ color: 'var(--color-foreground)' }}>
        Admin Portal
      </h1>
      <p className="text-sm md:text-base" style={{ color: 'var(--color-muted-foreground)' }}>
        Owner & Contributor Access
      </p>
    </div>
  );
};

export default BrandHeader;